import moment from "moment";
import { Card } from "shared/components/Card";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { formatToCurrency } from "shared/utils";
import { InfoRow } from "views/rent-reporting-id/components/InfoRow";
import { Subscriber } from "views/rent-reporting-id/types";

interface SubscriptionDetailsProps {
  renter?: Subscriber;
}

export const SubscriptionDetails = ({ renter }: SubscriptionDetailsProps) => {
  const { Unit, Property } = useUnitsPropertiesDictionary();

  return (
    <div className="flex-1 min-w-[350px]">
      <h2 className="mb-2 text-base font-medium text-content-1000">
        Subscription Details
      </h2>
      <Card className="min-h-[380px] p-6">
        <InfoRow title={Property} value={renter?.property?.name} />
        <InfoRow title={Unit} value={renter?.unit} />
        <InfoRow title="Address" value={renter?.address} />
        <InfoRow
          title="Move-in date"
          value={
            renter?.move_in_date
              ? moment(renter.move_in_date).format("ll")
              : "--"
          }
        />
        <InfoRow
          title="Move-out date"
          value={
            renter?.move_out_date
              ? moment(renter.move_out_date).format("ll")
              : "--"
          }
        />
        <InfoRow
          title="Lease end date"
          value={
            renter?.lease_end_date
              ? moment(renter.lease_end_date).format("ll")
              : "--"
          }
        />
        <InfoRow
          title="Monthly rent"
          value={
            typeof renter?.current_month_payment?.cents === "undefined"
              ? "--"
              : formatToCurrency({
                  cents: renter.current_month_payment.cents,
                  currency: "USD"
                })
          }
        />
      </Card>
    </div>
  );
};
